import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/connexion", { state: { resetOk: true } });
    } catch (err) {
      setError(formatApiError(err, "Réinitialisation impossible."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="font-heading text-xl" data-testid="reset-title">Nouveau mot de passe</CardTitle>
          <CardDescription>Choisis un nouveau mot de passe (8 caractères minimum).</CardDescription>
        </CardHeader>
        <CardContent>
          {!token ? (
            <div className="bg-orange-50 border border-orange-200 text-orange-800 text-sm rounded-lg px-4 py-3" data-testid="reset-no-token">
              Lien invalide. Demande un nouveau lien de réinitialisation.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-orange-50 border border-orange-200 text-orange-800 text-sm rounded-lg px-4 py-3" data-testid="reset-error">
                  {error}
                </div>
              )}
              <div className="space-y-2">
                <Label htmlFor="password">Nouveau mot de passe</Label>
                <Input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
              </div>
              <Button type="submit" className="w-full bg-teal-600 hover:bg-teal-700" disabled={loading} data-testid="reset-submit-button">
                {loading ? "Enregistrement..." : "Réinitialiser"}
              </Button>
            </form>
          )}
          <Link to="/connexion" className="mt-4 block text-center text-sm text-teal-700 hover:underline" data-testid="reset-back-login-link">
            Retour à la connexion
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
